<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { getExtSensorsStatus } from '../../../helpers/ext_sensor_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	let waitForResponse = false;

	const id = real_id(device.id),
		ext_sensors = getExtSensorsStatus(device),
		ext_names = { ...$devices[id]?.external_sensors_names },
		deviceOrigin = $devices[id],
		unnamed = $format('sensor_name_placeholder', {
			default: 'unnamed',
		}),
		saveNames = async () => {
			waitForResponse = true;
			deviceOrigin.external_sensors_names = ext_names;
			const res = await postReq(`/interface/device/save`, {
				id,
				data: JSON.stringify(deviceOrigin),
			});
			onSettingsResponse(res, device);
			waitForResponse = false;
		};
</script>

{#if ext_sensors.length}
	{#each ext_sensors as { sensor, icon }}
		<Text styleType="body-small" class="mb-s text-capitalize"
			>{sensor.type} sensor {sensor.extid}:</Text
		>
		<Input
			size="m"
			class="mb-s"
			{icon}
			label={unnamed}
			value={sensor.name}
			on:input={(e) =>
				(ext_names[`${sensor.extid}_${sensor.type}`] = {
					name: e.target['value'] || unnamed,
				})}
			id="input-er111bb"
			aria-labelledby="input-er111bb"
		/>
	{/each}
	<Button size="m" width="full" loading={waitForResponse} on:click={saveNames}
		>{$format('button_save', { default: 'Save' })}</Button
	>
{:else}
	<Text styleType="body-small" class="mt-s mb-s">
		{$format('sensor_name_no_sensors', {
			default: 'No attached sensors to name.',
		})}
	</Text>
{/if}
